import { AppName } from '../types/resources/app_name'
import { GroupResource, SourceType } from '../types/resources/group_resource'
import { FIVE_MINUTES } from '../utils/time'
import { useApiPaginator } from './use_api'

type UseGroupsProps = {
  source_app_name: AppName
  source_type: SourceType
}

export const useGroups = ({ source_app_name, source_type }: UseGroupsProps) => {
  return useApiPaginator<GroupResource>(
    {
      url: '/me/groups',
      data: {
        fields: {
          Group: [],
        },
        where: {
          source_app_name,
          source_type,
        },
        perPage: 100,
      },
      app: 'chat',
    },
    { staleTime: FIVE_MINUTES }
  )
}

export const useCanDisplayGroups = (props: UseGroupsProps) => {
  const { data: teams = [] } = useGroups(props)

  return teams?.length > 0
}
